import {
  APPROVAL_LIST_LOADED,
  APPROVAL_LOADING,
  LOADING_MODAL,
  APPROVAL_USER_LOADED,
} from '../components/actions/approvalTypes'

const initialState = {
  loading: true,
  approvalLoading: false,
  approvalUser: null,
  approvalList: null,
}

const approvalReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_LIST_LOADED:
      state.loading = false
      state.approvalLoading = false
      state.approvalList = action.payload
      return state
    case APPROVAL_LOADING:
      state.approvalLoading = true
      return state
    case LOADING_MODAL:
      state.modalLoading = true
      return state
    case APPROVAL_USER_LOADED:
      state.approvalUser = action.payload
      state.modalLoading = false
      return state
    default:
      return state
  }
}

export default approvalReducer
